import {
  FETCH_COMPANIES,
  FETCH_COMPANY,
  UPDATE_COMPANY,
  CREATE_COMPANY,
  DELETE_COMPANY,
  IMPERSONATE_DASHBOARD_USER,
  COMPANIES_FILTER_SET,
  COMPANIES_PAGE_SET,
  CURRENT_COMPANY_RESET
} from '../../constants/Constants';

export const fetchCompanies = () => ({ type: FETCH_COMPANIES.REQUESTED });
export const fetchCompany = companyId => ({ type: FETCH_COMPANY.REQUESTED, payload: { companyId } });
export const updateCompany = (payload, sendEmail) => ({
  type: UPDATE_COMPANY.REQUESTED,
  payload: { data: payload, sendEmail }
});
export const deleteCompany = companyId => ({ type: DELETE_COMPANY.REQUESTED, payload: { companyId } });
export const createCompany = payload => ({ type: CREATE_COMPANY.REQUESTED, payload });
export const setCompaniesFilter = filter => ({ type: COMPANIES_FILTER_SET, payload: filter });
export const setCompaniesPage = page => ({ type: COMPANIES_PAGE_SET, payload: { page } });
export const resetCurrentCompany = () => ({ type: CURRENT_COMPANY_RESET });
export const impersonateDashboardUser = userId => ({ type: IMPERSONATE_DASHBOARD_USER.REQUESTED, payload: { userId } });



// WEBPACK FOOTER //
// ./src/actions/entities/CompanyActions.js